import { Switch } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'

import {
  DirtyFieldLabel,
  TooltipInfoProps,
} from './dirty-field'

import { isFieldDirty } from './form-dirty-utils'
import React from 'react'

interface DirtySwitchProps<
  T extends Record<string, any>
> extends Omit<
  React.ComponentProps<typeof Switch>,
  'form' | 'label'
>, TooltipInfoProps {
  form: UseFormReturnType<T>
  field: keyof T
  label: string
}

export function DirtySwitch<
  T extends Record<string, any>,
>({
    form,
    field,
    label,
    tooltip,
    ...props
  }: DirtySwitchProps<T>) {
  return (
    <Switch
      label={
        <DirtyFieldLabel
          label={label}
          tooltip={tooltip}
          changed={isFieldDirty(
            form,
            field,
          )}
        />
      }
      checked={
        form.values[
          field
          ] as boolean
      }
      onChange={(event) =>
        form.setFieldValue(
          field as string,
          event.currentTarget.checked as any,
        )
      }
      {...props}
    />
  )
}